import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const MaintenanceBusFleetClearButton = ({
  handleClearRow,
  maintenanceBusFleet,
}) => {
  const isModified = maintenanceBusFleet.modified;

  if (!isModified) {
    return null;
  }

  return (
    <Button
      color="warning"
      outline
      onClick={() => handleClearRow(maintenanceBusFleet)}
      title="Deshacer cambios"
    >
      <i className="fa fa-times" />
    </Button>
  );
};

MaintenanceBusFleetClearButton.propTypes = {
  handleClearRow: PropTypes.func.isRequired,
  maintenanceBusFleet: PropTypes.shape({
    modified: PropTypes.bool,
  }).isRequired,
};

export default MaintenanceBusFleetClearButton;